'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toggle = exports.setStateConfiguration = undefined;

var _reduxActions = require('redux-actions');

var _actionTypes = require('../action-types');

var setStateConfiguration = exports.setStateConfiguration = (0, _reduxActions.createAction)(_actionTypes.CMS_COMPONENT_POPUP_SET_STATE_CONFIGURATION);
var toggle = exports.toggle = (0, _reduxActions.createAction)(_actionTypes.CMS_COMPONENT_POPUP_TOGGLE, function (id) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return { id: id, options: options };
});